module.exports = __webpack_public_path__ + "static/media/staff.d09d87c5.png";